export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'system_admin' | 'compliance_officer' | 'manager' | 'agent' | 'viewer';
  status: 'active' | 'inactive' | 'pending';
  lastLogin: Date | null;
  require2FA: boolean;
  createdAt: Date;
}

export const mockUsers: User[] = [
  {
    id: '1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@regal.com',
    role: 'system_admin',
    status: 'active',
    lastLogin: new Date('2025-10-02T08:30:00'),
    require2FA: true,
    createdAt: new Date('2024-01-15')
  },
  {
    id: '2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@regal.com',
    role: 'compliance_officer',
    status: 'active',
    lastLogin: new Date('2025-10-02T09:15:00'),
    require2FA: true,
    createdAt: new Date('2024-02-20')
  },
  {
    id: '3',
    firstName: 'Michael',
    lastName: 'Williams',
    email: 'michael.williams@regal.com',
    role: 'manager',
    status: 'active',
    lastLogin: new Date('2025-10-01T16:45:00'),
    require2FA: false,
    createdAt: new Date('2024-03-10')
  },
  {
    id: '4',
    firstName: 'Emily',
    lastName: 'Brown',
    email: 'emily.brown@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T10:00:00'),
    require2FA: false,
    createdAt: new Date('2024-04-05')
  },
  {
    id: '5',
    firstName: 'David',
    lastName: 'Martinez',
    email: 'david.martinez@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T07:20:00'),
    require2FA: false,
    createdAt: new Date('2024-04-12')
  },
  {
    id: '6',
    firstName: 'Jessica',
    lastName: 'Garcia',
    email: 'jessica.garcia@regal.com',
    role: 'viewer',
    status: 'active',
    lastLogin: new Date('2025-09-30T14:30:00'),
    require2FA: false,
    createdAt: new Date('2024-05-18')
  },
  {
    id: '7',
    firstName: 'Robert',
    lastName: 'Davis',
    email: 'robert.davis@regal.com',
    role: 'manager',
    status: 'active',
    lastLogin: new Date('2025-10-01T11:15:00'),
    require2FA: true,
    createdAt: new Date('2024-06-01')
  },
  {
    id: '8',
    firstName: 'Jennifer',
    lastName: 'Rodriguez',
    email: 'jennifer.rodriguez@regal.com',
    role: 'agent',
    status: 'inactive',
    lastLogin: new Date('2025-09-15T09:00:00'),
    require2FA: false,
    createdAt: new Date('2024-06-22')
  },
  {
    id: '9',
    firstName: 'William',
    lastName: 'Wilson',
    email: 'william.wilson@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T08:45:00'),
    require2FA: false,
    createdAt: new Date('2024-07-08')
  },
  {
    id: '10',
    firstName: 'Amanda',
    lastName: 'Anderson',
    email: 'amanda.anderson@regal.com',
    role: 'compliance_officer',
    status: 'active',
    lastLogin: new Date('2025-10-01T15:30:00'),
    require2FA: true,
    createdAt: new Date('2024-07-15')
  },
  {
    id: '11',
    firstName: 'Christopher',
    lastName: 'Taylor',
    email: 'christopher.taylor@regal.com',
    role: 'viewer',
    status: 'active',
    lastLogin: new Date('2025-10-02T09:30:00'),
    require2FA: false,
    createdAt: new Date('2024-08-03')
  },
  {
    id: '12',
    firstName: 'Michelle',
    lastName: 'Thomas',
    email: 'michelle.thomas@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T10:15:00'),
    require2FA: false,
    createdAt: new Date('2024-08-20')
  },
  {
    id: '13',
    firstName: 'Daniel',
    lastName: 'Moore',
    email: 'daniel.moore@regal.com',
    role: 'manager',
    status: 'pending',
    lastLogin: null,
    require2FA: false,
    createdAt: new Date('2025-09-28')
  },
  {
    id: '14',
    firstName: 'Lisa',
    lastName: 'Jackson',
    email: 'lisa.jackson@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-01T13:45:00'),
    require2FA: false,
    createdAt: new Date('2024-09-10')
  },
  {
    id: '15',
    firstName: 'Matthew',
    lastName: 'White',
    email: 'matthew.white@regal.com',
    role: 'viewer',
    status: 'inactive',
    lastLogin: new Date('2025-08-20T10:00:00'),
    require2FA: false,
    createdAt: new Date('2024-09-25')
  },
  {
    id: '16',
    firstName: 'Ashley',
    lastName: 'Harris',
    email: 'ashley.harris@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T08:00:00'),
    require2FA: false,
    createdAt: new Date('2024-10-05')
  },
  {
    id: '17',
    firstName: 'Joshua',
    lastName: 'Martin',
    email: 'joshua.martin@regal.com',
    role: 'agent',
    status: 'active',
    lastLogin: new Date('2025-10-02T09:50:00'),
    require2FA: false,
    createdAt: new Date('2024-10-18')
  },
  {
    id: '18',
    firstName: 'Stephanie',
    lastName: 'Thompson',
    email: 'stephanie.thompson@regal.com',
    role: 'viewer',
    status: 'active',
    lastLogin: new Date('2025-09-29T16:20:00'),
    require2FA: false,
    createdAt: new Date('2024-11-02')
  }
];

export const getRoleDisplayName = (role: User['role']): string => {
  const roleNames: Record<User['role'], string> = {
    system_admin: 'System Administrator',
    compliance_officer: 'Compliance Officer',
    manager: 'Manager',
    agent: 'Agent',
    viewer: 'Viewer'
  };
  return roleNames[role] || role;
};

export const getRoleBadgeColor = (role: User['role']): string => {
  const colors: Record<User['role'], string> = {
    system_admin: 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300',
    compliance_officer: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
    manager: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
    agent: 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300',
    viewer: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300'
  };
  return colors[role];
};

export const getStatusBadgeColor = (status: User['status']): string => {
  const colors: Record<User['status'], string> = {
    active: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
    inactive: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
    pending: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300'
  };
  return colors[status];
};
